<template>
    <div class="block-editor akinon-find-nearest-stock">
        <section class="active-connection">
            <div data-small="true" class="logos">
                <div class="logo1">
                    <img class="custom-block-logo" src="/static/img/supsis-logo2.png" />
                </div>
                <span class="material-icons"> add </span>
                <div class="logo2">
                    <img class="custom-block-logo" src="/static/img/akinon.png" />
                </div>
            </div>
            <div class="active-connection-text">
                <div><span>Connected with</span> <b>Metabase API Akinon - Aydınlı </b></div>
            </div>
        </section>
        <div class="akinon-find-nearest-stock-wrapper">
            <div class="inputTitle">{{ $t("akinon.productSKU") }}</div>
            <div class="text-editor-wrapper" key="sku">
                <TiptapEditor
                    v-model="clone.sku"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    :placeholder="$t('akinon.typeOrSelectSKU')"
                    :rows="1"
                />
            </div>

            <div class="inputTitle">{{ $t("akinon.latitude") }}</div>
            <div class="text-editor-wrapper" key="latitude">
                <TiptapEditor
                    v-model="clone.latitude"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    :placeholder="$t('akinon.latitudeDesc')"
                    :rows="1"
                />
            </div>

            <div class="inputTitle">{{ $t("akinon.longitude") }}</div>
            <div class="text-editor-wrapper" key="longitude">
                <TiptapEditor
                    v-model="clone.longitude"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    :placeholder="$t('akinon.longitude')"
                    :rows="1"
                />
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import TiptapEditor from "../../common/TiptapEditor";
import _ from "lodash";

const log = log2("AkinonFindNearestStock");
export default {
    name: "AkinonFindNearestStock",
    components: { TiptapEditor },
    props: {
        value: {
            type: Object,
            default: () => ({
                sku: "{{akinon_sku}}",
                latitude: "{{akinon_latitude}}",
                longitude: "{{akinon_longitude}}",
            }),
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    mounted() {
        log("mounted", this.value);
    },
    watch: {
        clone: {
            deep: true,
            handler: function (val) {
                log("clone changed", val);
                this.$emit("input", val);
            },
        },
        value(val) {
            if (_.isEqual(val, this.clone)) {
                return;
            }
            this.clone = _.cloneDeep(val);
        },
    },
};
</script>

<style lang="scss">
.block-editor.akinon-find-nearest-stock {
    padding: 30px 30px 0;

    .active-connection {
        align-items: center;
        background: #fff;
        border-radius: 6px;
        display: flex;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        overflow: hidden;
        padding: 20px;
        width: 100%;
        word-break: break-word;

        .logos {
            align-items: center;
            display: flex;
            flex-shrink: 0;
            margin-right: 15px;
            margin-top: 4px;

            .logo1 {
                background: #4a6586;
            }

            .logo2 {
                background: #d0292e;
            }

            .logo1,
            .logo2 {
                height: 30px;
                padding: 4px;
                width: 30px;
            }
        }
    }

    .active-connection-text {
        flex-grow: 1;
        flex-shrink: 0;
        width: 0;

        div {
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: pre-wrap;
        }
    }

    .akinon-find-nearest-stock-wrapper {
        .inputTitle {
            margin-bottom: 10px;
            margin-top: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .editable-editor {
            p {
                margin-bottom: 0;
            }
        }
    }
}
</style>
